import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiInstagram, FiTwitter, FiMail, FiArrowRight } = FiIcons;

export default function Footer() {
  return (
    <footer className="bg-[var(--navy)] text-[var(--kraft-light)] pt-24 pb-12 overflow-hidden relative">
      {/* Decorative Brand Text */}
      <div className="absolute -bottom-10 -right-20 text-[12vw] font-bold text-white/[0.03] select-none pointer-events-none italic whitespace-nowrap">
        CLEANNEST CIRCULAR
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-24 mb-20">
          
          <div className="lg:col-span-5">
            <a href="#" className="text-4xl font-bold tracking-tighter text-white mb-8 block">
              CleanNest<span className="text-[var(--mint)]">.</span>
            </a>
            <p className="text-gray-400 text-lg leading-relaxed mb-10 max-w-sm">
              An intentional home care ecosystem. We design for longevity, transparency, and a plastic-free future.
            </p>
            <div className="flex gap-6">
              <a href="#" className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-gray-400 hover:text-[var(--mint)] hover:border-[var(--mint)] transition-all duration-300"><SafeIcon icon={FiInstagram} /></a>
              <a href="#" className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-gray-400 hover:text-[var(--mint)] hover:border-[var(--mint)] transition-all duration-300"><SafeIcon icon={FiTwitter} /></a>
              <a href="#" className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-gray-400 hover:text-[var(--mint)] hover:border-[var(--mint)] transition-all duration-300"><SafeIcon icon={FiMail} /></a>
            </div>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-bold text-white mb-8 uppercase tracking-[0.2em] text-[10px]">Curation</h4>
            <ul className="space-y-4 text-gray-400 text-sm font-medium">
              <li><a href="#" className="hover:text-[var(--mint)] transition-colors">Starter Kits</a></li>
              <li><a href="#" className="hover:text-[var(--mint)] transition-colors">Refill Pods</a></li>
              <li><a href="#" className="hover:text-[var(--mint)] transition-colors">Glassware</a></li>
              <li><a href="#" className="hover:text-[var(--mint)] transition-colors">Subscriptions</a></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-bold text-white mb-8 uppercase tracking-[0.2em] text-[10px]">Stewardship</h4>
            <ul className="space-y-4 text-gray-400 text-sm font-medium">
              <li><a href="#how-it-works" className="hover:text-[var(--mint)] transition-colors">The Loop</a></li>
              <li><a href="#impact" className="hover:text-[var(--mint)] transition-colors">Impact Data</a></li>
              <li><a href="#" className="hover:text-[var(--mint)] transition-colors">Ingredients</a></li>
              <li><a href="#guides" className="hover:text-[var(--mint)] transition-colors">Support</a></li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-bold text-white mb-8 uppercase tracking-[0.2em] text-[10px]">Join the Workspace</h4>
            <p className="text-gray-400 text-sm mb-6 leading-relaxed">Receive occasional updates on circularity and new scent profiles.</p>
            <form className="relative" onSubmit={(e) => e.preventDefault()}>
              <input 
                type="email" 
                placeholder="Email Address" 
                className="bg-white/5 border border-white/10 text-white px-5 py-4 w-full focus:outline-none focus:border-[var(--mint)] transition-colors rounded-sm text-sm"
              />
              <button 
                type="submit"
                className="absolute right-2 top-2 bottom-2 px-4 bg-[var(--mint)] text-[var(--navy)] font-bold rounded-sm hover:bg-white transition-all flex items-center"
              >
                <SafeIcon icon={FiArrowRight} className="text-lg" />
              </button>
            </form>
          </div>

        </div>

        <div className="pt-12 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-8">
          <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8 text-[10px] text-gray-500 font-bold uppercase tracking-[0.2em]">
            <p>&copy; {new Date().getFullYear()} CleanNest Refill</p>
            <div className="flex gap-8">
              <a href="#" className="hover:text-white transition-colors">Privacy</a>
              <a href="#" className="hover:text-white transition-colors">Terms</a>
              <a href="#" className="hover:text-white transition-colors">Accessibility</a>
            </div>
          </div>
          <div className="flex items-center gap-1 text-[10px] text-gray-500 font-bold tracking-[0.2em]" style={{ textTransform: 'none' }}>
            <span>Made by</span>
            <a href="https://diglab.ai/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors" style={{ textTransform: 'none' }}>DigLab.ai</a>
            <span>and</span>
            <a href="https://linglinkai.cn/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors" style={{ textTransform: 'none' }}>LingLinkAI.cn</a>
          </div>
        </div>
      </div>
    </footer>
  );
}